import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { SpacingType } from '@sdk/components/ui/spacing/SpacingStyle';
import { FlexType } from '@sdk/components/ui/spacing/FlexCss';

import EmptySearchSvg from '@web/assets/svg/images/empty-search.svg';

type Props = SpacingType & FlexType;

export const EmptySearchResults = (containerProps: Props) => {
  return (
    <Column alignItems="center" {...containerProps}>
      <Column mBottom={20}>
        <EmptySearchSvg />
      </Column>
      <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
        {gettext('No results!')}
      </Text14>
      <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
        {gettext('Try modifying your search or checking for typos.')}
      </Text14>
    </Column>
  );
};
